import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const outOfServiceStatusSlice = createSlice({
  name: 'outOfServiceStatus',
  initialState: {} as any,
  reducers: {
    updateOutOfServiceStatus: (state, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})
export const outOfServiceStatusActionsCreator = outOfServiceStatusSlice.actions

export default outOfServiceStatusSlice
